export type VehicleFilter = {
  value: string;
  label: string;
  hasLicensePlate: boolean;
  showLength: boolean;
  showFuelType: boolean;
};

export const configVehicles: VehicleFilter[] = [
  {
    value: "CAR",
    label: "Car",
    hasLicensePlate: true,
    showLength: false,
    showFuelType: true
  },
  {
    value: "CARH",
    label: "Car over 2.2m in height",
    hasLicensePlate: true,
    showLength: false,
    showFuelType: true
  },
  {
    value: "CCVN",
    label: "Car towing a caravan",
    hasLicensePlate: true,
    showLength: true,
    showFuelType: true
  },
  {
    value: "CTOW",
    label: "Car towing a trailer",
    hasLicensePlate: true,
    showLength: true,
    showFuelType: true
  },
  {
    value: "MHOME",
    label: "Motorhome",
    hasLicensePlate: true,
    showLength: true,
    showFuelType: true
  },
  {
    value: "VAN",
    label: "Domestic Van",
    hasLicensePlate: true,
    showLength: true,
    showFuelType: true
  },
  {
    value: "MC",
    label: "Motorcycle / Scooter / Tricycle",
    hasLicensePlate: true,
    showLength: false,
    showFuelType: true
  },
  {
    value: "BIC",
    label: "Bicycle",
    hasLicensePlate: false,
    showLength: false,
    showFuelType: true
  },
];
